import React from "react";
import { Button, Form, FormGroup, Label, Input , Col, Row } from 'reactstrap';
import Chatx from '../chat/chat'

import NotificationAlert from "react-notification-alert";
import ModalForm from '../modal/modal'

import AuthService from "services/auth.service";

import Timestamp from "react-timestamp";
import Uploader from '../upload/upload'
import Attachments from '../upload/alluploads'
import Loader from "react-loader-spinner";

class Tform extends React.Component {



  constructor(props) {
    super(props);

    const Currentuser = AuthService.getCurrentUser();


        const UserRoles = Currentuser.roles;

        const isAgent = UserRoles.includes('ROLE_AGENT');


    this.state = {
        queue:"",
        category:"",
        sub:"",
        agent:"",
        state:"",
        created:"",
        updated:"",
        sapreqnum:"",
        author:"",
        formcatgs:[],
        prmqueue:'',
        formsubcats:[],
        qusers:[],
        oldstates:{},
        loading:true,
        LogsOpen:false,
        AttachOpen:false,

        Logs:[],
        isAgent:isAgent


    };
    this.viewData(this.props.tktid) ;
     


     this.Getlogs()
    //remove to generalize
  }



  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }
  





















  

componentDidMount() {

}

componentWillUnmount(){

  clearInterval(this.interval);

  
}







handleclosedSubmit = (e) =>{
  e.preventDefault();

  let loguser = AuthService.getCurrentUser().username;
alert('Requested To Open')


}


handleactiveSubmit = (e) =>{
  e.preventDefault();

  let loguser = AuthService.getCurrentUser().username;
alert('Requested To Close')


}














LogsOpen = () => this.setState({ LogsOpen: true });
closeLogs = () => {this.setState({ LogsOpen: false ,targetid:''})}

AttachOpen = () => this.setState({ AttachOpen: true });
closeAttach = () => {this.setState({ AttachOpen: false})}



handleChange = (e) =>{ 
  


//handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})


}

  render(){


          const logs =this.state.Logs.map(log =><p key={log.id}><strong><Timestamp date={log.createdAt} />: </strong> {log.logmsg}</p>
            )

            
   let alllogs = <div><strong> <Timestamp date={this.state.created} /> </strong><p>User {this.state.author} Has Created The Ticket</p>{logs}</div>;

   let attachmentcontent = <div><Uploader tktid={this.props.tktid} submitexist/><br/><hr /><Attachments tktid={this.props.tktid} /></div>



    return(
<div>
<NotificationAlert ref="notificationAlert" />


{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={100}
        width={100}
        timeout={5000} //3 secs
      /></Row>
:


<Form onSubmit={e => { e.preventDefault(); }}>


{ this.state.LogsOpen ? 
          <ModalForm 
            closeModal={this.closeLogs} 
            isOpen={this.state.LogsOpen} 
            title={"Action Logs"}
            hoste={alllogs}
            size="md"
          /> 
          : 
          null 
        }


        { this.state.AttachOpen ? 
          <ModalForm 
            closeModal={this.closeAttach} 
            isOpen={this.state.AttachOpen} 
            title={"Attachments"}
            hoste={attachmentcontent}
            size="md"
          /> 
          : 
          null 
        }



      <FormGroup>
        <Row>


        <Col xs={12} md={4}>

<Label for="exampleSelect"><strong>Client</strong></Label>
<Input type="select" name="client" id="categasdao" onChange={this.handleChange} value={this.state.client} >

<option>{this.state.client}</option>

</Input>
</Col>


<Col xs={12} md={4}>

          <Label for="exampleSelect"><strong>Category</strong></Label>
          <Input type="select" name="category" id="catego" onChange={this.handleChange} value={this.state.category} required>

          <option>{this.state.category}</option>

          </Input>
          </Col>

          <Col xs={12} md={4}>

          <Label for="exampleSelect"><strong>Sub-Category</strong></Label>
          <Input type="select" name="sub" id="sub" onChange={this.handleChange}  value={this.state.sub} required>
          <option>{this.state.sub}</option>
          </Input>
          </Col>
          </Row>
          <br />
        <Row>
        <Col xs={12} md={4}>
          <Label for="exampleSelect"><strong>Queue</strong></Label>
          <Input type="select" name="queue" id="exampleSelect" onChange={this.handleChange}  value={this.state.queue}>
          <option>{this.state.queue}</option>

          </Input>
          </Col>

          <Col xs={12} md={4}>
          <Label for="exampleSelect"><strong>Assigned To</strong></Label>
          <Input type="select" name="agent" id="agent" onChange={this.handleChange}  value={this.state.agent}>
          <option>{this.state.agent}</option>
          </Input>
          </Col>
          <Col xs={12} md={4}>

          <Label for="exampleSelect"><strong>Status</strong></Label>
          <Input type="select" name="state" id="sttate" onChange={this.handleChange}  value={this.state.state}>
          <option>{this.state.state}</option>

          </Input>
          </Col>


</Row>






<br />



        </FormGroup>

        <FormGroup>

<Row>

<Col xs={12} md={6}>

  <strong >Created at: </strong>

  <Timestamp  date={this.state.created} /> <span> </span>
  <br/>

  <strong >Last Update: </strong>

  <Timestamp  date={this.state.updated} /> <span> </span>
  <br/>


{this.state.queue === 'SAP' ? 

<span>
<br/>
<strong >Request#: </strong>

 <span>{this.state.sapreqnum}</span>






</span>

:null


}

  </Col>



<Col xs={12} md={6}>


          <Button variant="contained"  type="button" onClick={this.AttachOpen} className="pull-right" >
              Attachments
          </Button>

          <Button variant="contained" type="button" onClick={this.LogsOpen} className="pull-right">
              Action Logs
          </Button>


          </Col>









  </Row>




</FormGroup>







        <FormGroup>
          <Label for="exampleText"><strong>Description</strong></Label>
          <Input type="textarea" name="descddfr" id="tktsss"  onChange={this.handleChange}  value={this.state.descr} />
          {/*this.state.state === "Completed" ?  <Button variant="primary" type="button" onClick={ this.handleclosedSubmit} style={{backgroundColor:'rgb(101, 153, 57)'}} >
Re-Open
</Button> :null
*/}
          </FormGroup>

<FormGroup>
{this.state.state !== 'Closed' && this.state.state !== 'Canceled' ? <div><strong>Case Notes</strong> <Chatx tktid={this.props.tktid}  /></div>: 
 this.state.state === 'Closed' ? <div><Chatx tktid={this.props.tktid} noinput /><br/><strong>This Ticket Has Been Automatically Closed By System After 7 Days From Completion Date </strong> </div>:
 <div><Chatx tktid={this.props.tktid} noinput /><br/><strong>This Ticket Has Been Canceled By IT Department, For More info Please Contact Site Support Agent </strong></div>
}
</FormGroup>
</Form>

}





</div>
    )
  }
}



export default Tform;